/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppAccountUpdateFirstContactAutomationPathParams,
	WhatsAppAccountUpdateFirstContactAutomationRequest,
	WhatsAppAccountUpdateFirstContactAutomationResponse,
} from '../types/WhatsAppAccountUpdateFirstContactAutomation'

/**
 * PATCH /organisations/:organisationId/whatsapp-account/first-contact-automation
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::updateFirstContactAutomation
 */
export async function whatsAppAccountUpdateFirstContactAutomation(
	organisationId: WhatsAppAccountUpdateFirstContactAutomationPathParams['organisationId'],
	data: WhatsAppAccountUpdateFirstContactAutomationRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAccountUpdateFirstContactAutomationResponse>> {
	return axiosInstance.patch(
		`/organisations/${organisationId}/whatsapp-account/first-contact-automation`,
		data,
		config,
	)
}
